import { useMediaQuery } from "usehooks-ts";
import { cn } from "~/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { Markdown } from "./Markdown";

interface IBanner {
  image: {
    url: string;
    dimensions: {
      width: number;
      height: number;
    };
  };
  title: string;
  description: string;
  buttonLabel: string;
  buttonLink: string;
}

export function Banner({
  image,
  title,
  description,
  buttonLabel,
  buttonLink,
}: Readonly<IBanner>): JSX.Element {
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  return (
    <div className="container">
      <div
        className={cn(
          isDesktop ? "p-[50px]" : "p-4",
          "flex w-full rounded-lg items-center flex-1 self-stretch bg-gradient-to-r from-[#171717] via-[#5E5E5E] to-[#5E5E5E]",
        )}
      >
        <div className={cn(
          isDesktop ? "gap-[50px]" : "gap-4",
          "flex w-full flex-col md:flex-row",
        )}>
          <div className={cn(isDesktop && "max-w-[300px]", "md:w-1/2")}>
            <Image
              width={image.dimensions?.width}
              height={image.dimensions?.height}
              alt={image.url ?? ""}
              src={image.url ?? ""}
              className="h-full w-full rounded-[12px] object-cover"
            />
          </div>
          <div className="md:w-1/2 flex flex-col justify-between text-white">
            <div>
              <h2
                className={cn(
                  isDesktop ? "text-xl" : "text-lg",
                  "content-center font-bold",
                )}
              >
                <Markdown content={title} />
              </h2>
              <Markdown content={description} />
            </div>
            <Link
              href={buttonLink}
              className={cn(
                isDesktop ? "max-w-[300px]" : "w-full",
                "flex justify-center rounded-[4px] border border-black bg-black p-2 mt-4",
              )}
            >
              <span
                className={cn(isDesktop ? "text-lg" : "text-sm", "font-bold")}
              >
                {buttonLabel}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
